import { StyleProp } from '@front10/base-elements';
import * as React from 'react';
import { DatePicker } from './DatePicker';
import { BlackoutDates } from './../../../components/containers/VerticalBookingContainer/blackoutDates';
import type { ThemeUICSSObject } from '@theme-ui/css';
import type { BookingFilterLabels } from '../../containers/VerticalBookingContainer/BookingFilters';
export * from './datePickerI18n';

export interface Dates {
  start?: Date;
  end?: Date;
  startTime?: string;
  endTime?: string;
  isFlexibleDates?: boolean;
}

export interface DateRangePickerProps {
  selectedDates?: {
    startDate: Date | null;
    endDate: Date | null;
  };
  setSelectedDates?: (dates: { startDate: Date | null; endDate: Date | null }) => void;
  enableAutomaticStatusNavBarButtons?: boolean;
  flexibleDates?: boolean;
  defaultValue?: Dates;
  onChange?: (value: Dates) => void;
  onKeyDownHandleEnterAction?: (value: any) => void;
  sx?: StyleProp;
  className?: string;
  showTimePickers?: boolean;
  columns?: number[] | number;
  startDateErrorMessage?: React.ReactNode;
  startDateTimeErrorMessage?: React.ReactNode;
  endDateErrorMessage?: React.ReactNode;
  endDateTimeErrorMessage?: React.ReactNode;
  startDateHasError?: boolean;
  endDateHasError?: boolean;
  timeOptions?: Array<{ value: string; label: string }>;
  inputFormat?: string;
  singleSelection?: boolean;
  minDate?: number | string;
  maxDate?: number | string;
  maxRange?: number;
  minRange?: number;
  dateFormat?: string;
  dateFormatOnEdit?: string;
  dayFormat?: string;
  showFlexibleDates?: boolean;
  UNSTABLE_hideDisabledInput?: boolean;
  labels?: BookingFilterLabels;
  activeTab?: number;
  currentTab?: number;
  numberOfMonths?: number;
  trigger?: any;
  fetchBlackoutDates?: BlackoutDates | null;
  blackoutDatesIntegration?: boolean;
  flightType?: string;
  selectedOrigin?: {
    label: string;
    value: string;
  };
  selectedDestination?: {
    label: string;
    value: string;
  };
  setValue?: (key: string, value: any) => void;
  getValues?: () => any;
  allowHoverStyleInRange?: boolean;
  customInputStyle?: React.CSSProperties | ThemeUICSSObject;
  shouldFlip: boolean;
}

export { DatePicker as DateRangePicker };
